<div class="main-row g-centered">
  <div class="main-column">
    <slot />
  </div>

  {#if $$slots.aside}
    <div class="aside-column">
      <slot name="aside" />
    </div>
  {/if}
</div>

<style lang="scss">
  .main-row {
    display: grid;
    grid-auto-flow: row;
    grid-column-gap: 40px;

    @include md {
      grid-auto-flow: column;
      grid-template-columns: 21fr 10fr;
    }

    @include md-down {
      padding-left: 0;
      padding-right: 0;
    }

    @include md {
      :global(.g-centered) {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }

  .main-column {
    grid-row: 2;

    @include md {
      grid-row: 1;
    }
  }
</style>
